import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const cashReturn = {
  namespaced: true,
  state: {
    cashReturns: []
  },
  getters,
  mutations,
  actions
};
